import _ from 'lodash';
import React, { Component } from 'react';
import Field from './field';
import { observer } from 'mobx-react';
import {useForm} from 'react-hook-form';
const  GenericField = observer((props) => {
    // const { register } = useForm();
    const {
        type,
        fieldKey,
        defaultValue,
        inputClass,
        placeholder,
        tabIndex,
        required = false,
        focusOnRender = false,
        register = () => {},
        onBlur = () => {},
        onChange = () => {}
    } = props;

    const addrs = {
        defaultValue,
        type,
        placeholder,
        tabIndex,
        id: fieldKey,
        name: fieldKey,
        'data-key': fieldKey,
        'data-ta': fieldKey,
        autoFocus: focusOnRender
    };

    if (_.isString(inputClass)) {

        addrs.className = inputClass;
    }

    return (
        <Field
            {...props}
            inputComp={<input {...register(fieldKey, { required, onBlur, onChange })} {...addrs} />}
        />
    );
});

export default (type) => (
    (props) => (
        <GenericField type={type} {...props} />
    )
);